<div id="modal" class="modal" #modalElement [ngClass]="classes">

    <ng-template #dialogComponent></ng-template>

    <div class="modal-backdrop" (click)="onClose()"></div>
</div>
